import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20">
    <g id="SVG">
      <g id="Mask group">
        <mask id="mask0_4095_21818" width="21" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
          <g id="Group">
            <path id="Vector" fill="#D9D9D9" d="M.73 0h20v20h-20z"></path>
          </g>
        </mask>
        <g mask="url(#mask0_4095_21818)">
          <g id="Group_2">
            <path
              id="share"
              fill={props.fill || '#53A6D6'}
              d="M15.5 18.667a2.4 2.4 0 0 1-1.77-.73 2.4 2.4 0 0 1-.73-1.77q0-.125.063-.584l-5.855-3.416a2.47 2.47 0 0 1-1.708.666 2.4 2.4 0 0 1-1.77-.729 2.4 2.4 0 0 1-.73-1.77q0-1.042.73-1.772a2.4 2.4 0 0 1 1.77-.729 2.48 2.48 0 0 1 1.708.667l5.855-3.417a1.4 1.4 0 0 1-.053-.28A4 4 0 0 1 13 4.5q0-1.042.73-1.77A2.4 2.4 0 0 1 15.5 2a2.4 2.4 0 0 1 1.77.73q.73.728.73 1.77t-.73 1.77A2.4 2.4 0 0 1 15.5 7a2.48 2.48 0 0 1-1.708-.667L7.938 9.75q.041.145.052.281a4 4 0 0 1 0 .604 1.4 1.4 0 0 1-.053.282l5.855 3.416a2.47 2.47 0 0 1 1.708-.666q1.042 0 1.77.729.73.729.73 1.77 0 1.042-.73 1.771a2.4 2.4 0 0 1-1.77.73m0-1.667q.354 0 .594-.24t.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.593.24.24.594.24m-10-5.833q.354 0 .594-.24t.24-.594a.8.8 0 0 0-.24-.593.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.593q0 .354.24.594t.594.24m10-5.834q.354 0 .594-.24.24-.239.24-.593a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594q0 .354.24.594t.594.24"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgIcon;
